import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdArrowBack } from 'react-icons/md';

const ArrowBack: React.FC<IconBaseProps> = (props) => (
  <MdArrowBack {...props} />
);

export default ArrowBack;
